"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.mapDispatchToProps = exports["default"] = exports.BaseWidget = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _WidgetChildren = _interopRequireDefault(require("./WidgetChildren"));

var _baseWidgetModule = _interopRequireDefault(require("./base-widget.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var BaseWidget = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseWidget, _React$Component);

  var _super = _createSuper(BaseWidget);

  function BaseWidget(props) {
    var _this;

    _classCallCheck(this, BaseWidget);

    _this = _super.call(this, props);
    _this.showDeleteDialog = _this.showDeleteDialog.bind(_assertThisInitialized(_this));
    _this.onDeleteDialogClosed = _this.onDeleteDialogClosed.bind(_assertThisInitialized(_this));
    _this.showSettings = _this.showSettings.bind(_assertThisInitialized(_this));
    _this.hideSettings = _this.hideSettings.bind(_assertThisInitialized(_this));
    _this.toggleConnect = _this.toggleConnect.bind(_assertThisInitialized(_this));
    _this.state = {
      settingsDialogHasNeverBeenActive: true,
      deleteDialogHasNeverBeenActive: true,
      showSettings: false,
      deleteDialogActive: false
    };
    return _this;
  }

  _createClass(BaseWidget, [{
    key: "onDeleteDialogClosed",
    value: function onDeleteDialogClosed(response) {
      this.setState({
        deleteDialogActive: false
      });
      this.props.removeWidget(response, this.props.portalId);
    }
  }, {
    key: "showDeleteDialog",
    value: function showDeleteDialog() {
      this.setState({
        deleteDialogActive: true,
        deleteDialogHasNeverBeenActive: false
      });
    }
  }, {
    key: "hideSettings",
    value: function hideSettings() {
      this.setState({
        showSettings: false
      });
    }
  }, {
    key: "showSettings",
    value: function showSettings() {
      this.setState({
        showSettings: true,
        settingsDialogHasNeverBeenActive: false
      });
    }
  }, {
    key: "toggleConnect",
    value: function toggleConnect() {
      if (this.props.isConnected) {
        this.props.onDisconnectWidget(this.props.id, this.props.portalId);
      } else {
        this.props.onConnectWidget(this.props.id, this.props.portalId);
      }
    }
    /**
     * This method renders the settings dialog if settings are present
     * The settings dialog is rendered the first time the dialog is made active
     * @returns {*}
     * @private
     */

  }, {
    key: "renderSettings",
    value: function renderSettings() {
      var _this2 = this;

      if (!this.props.settings || this.state.settingsDialogHasNeverBeenActive) {
        return null;
      }

      var actions = [/*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
        primary: true,
        className: "ml-3",
        onClick: function onClick() {
          _this2.hideSettings();

          if (_this2.props.onSettingsCancel) {
            _this2.props.onSettingsCancel();
          }
        }
      }, this.props.intl.formatMessage({
        id: 'common.cancel'
      }))];

      if (this.props.onSettingsSave) {
        actions.push( /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
          primary: true,
          raised: true,
          disabled: this.props.hasSettingsError,
          className: "ml-3",
          onClick: function onClick() {
            _this2.hideSettings();

            if (_this2.props.onSettingsSave) {
              _this2.props.onSettingsSave();
            }
          }
        }, this.props.intl.formatMessage({
          id: 'common.save'
        })));
      }

      return /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.BasisDialog, {
        active: this.state.showSettings,
        title: this.props.settingsLabel,
        content: this.props.settings,
        actions: actions,
        onRequestCancel: this.props.onSettingsCancel,
        onRequestClose: this.props.onSettingsSave
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          isEditActive = _this$props.isEditActive,
          icon = _this$props.icon,
          label = _this$props.label,
          connectionDisabled = _this$props.connectionDisabled,
          isConnected = _this$props.isConnected,
          settings = _this$props.settings,
          deletable = _this$props.deletable,
          isBorder = _this$props.isBorder,
          intl = _this$props.intl,
          children = _this$props.children;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_baseWidgetModule["default"].widget, className),
        role: "region"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_baseWidgetModule["default"].widgetHeader, {
          'cursor-move draggable-handle': isEditActive
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _baseWidgetModule["default"].widgetIcon
      }, icon), /*#__PURE__*/_react["default"].createElement("span", {
        className: _baseWidgetModule["default"].widgetName
      }, label), connectionDisabled ? null : /*#__PURE__*/_react["default"].createElement("span", {
        title: intl.formatMessage({
          id: 'widgets.connect'
        })
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Connection, {
        className: (0, _classnames["default"])(_baseWidgetModule["default"].widgetConnectStatus, 'cursor-pointer draggable-cancel', _defineProperty({}, _baseWidgetModule["default"].connected, isConnected)),
        onClick: this.toggleConnect
      })), settings ? /*#__PURE__*/_react["default"].createElement("span", {
        title: intl.formatMessage({
          id: 'widgets.settings'
        }),
        onClick: this.showSettings
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Settings, {
        className: (0, _classnames["default"])(_baseWidgetModule["default"].settingsToggle, 'draggable-cancel')
      })) : null, isEditActive && deletable ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
        className: (0, _classnames["default"])(_baseWidgetModule["default"].deleteWidget, 'h-6 w-6 draggable-cancel'),
        onClick: this.showDeleteDialog
      }) : null), /*#__PURE__*/_react["default"].createElement(_WidgetChildren["default"], {
        isEditActive: isEditActive,
        settingsActive: this.state.showSettings,
        isBorder: isBorder
      }, children), this.renderSettings(), !deletable || this.state.deleteDialogHasNeverBeenActive ? null : /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.ConfirmDialog, {
        active: this.state.deleteDialogActive,
        title: intl.formatMessage({
          id: 'widgets.delete.title'
        }),
        content: intl.formatMessage({
          id: 'widgets.delete.confirmationText'
        }),
        confirmText: intl.formatMessage({
          id: 'widgets.delete.confirm'
        }),
        cancelText: intl.formatMessage({
          id: 'widgets.delete.cancel'
        }),
        onCloseDialog: this.onDeleteDialogClosed
      }));
    }
  }]);

  return BaseWidget;
}(_react["default"].Component);

exports.BaseWidget = BaseWidget;

var noop = function noop() {};

BaseWidget.propTypes = {
  id: _propTypes["default"].number.isRequired,
  portalId: _propTypes["default"].number.isRequired,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  icon: _propTypes["default"].node,
  connectionDisabled: _propTypes["default"].bool,
  isConnected: _propTypes["default"].bool,
  label: _propTypes["default"].node,
  settings: _propTypes["default"].node,
  settingsLabel: _propTypes["default"].node,
  isEditActive: _propTypes["default"].bool,
  deletable: _propTypes["default"].bool,
  onSettingsCancel: _propTypes["default"].func,
  onSettingsSave: _propTypes["default"].func,
  onConnectWidget: _propTypes["default"].func,
  onDisconnectWidget: _propTypes["default"].func,
  removeWidget: _propTypes["default"].func,
  intl: _nicbaseTranslation.intlShape.isRequired,
  isBorder: _propTypes["default"].bool,
  hasSettingsError: _propTypes["default"].bool
};
BaseWidget.defaultProps = {
  className: '',
  connectionDisabled: false,
  isConnected: false,
  label: '',
  settingsLabel: '',
  onSettingsCancel: noop,
  onSettingsSave: noop,
  removeWidget: noop,
  onConnectWidget: noop,
  onDisconnectWidget: noop,
  isEditActive: false,
  deletable: true,
  icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Widget, null),
  isBorder: true,
  settings: null,
  children: null,
  hasSettingsError: false
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var widget = state.widgets[ownProps.id] || {};
  return {
    isConnected: widget.connected === true,
    isEditActive: state.appVariables.editModeActive
  };
};

exports.mapStateToProps = mapStateToProps;

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    removeWidget: function removeWidget(response, portalId) {
      if (response === true) {
        dispatch((0, _nicbaseReducers.removeWidget)(ownProps.id, portalId));
      }
    },
    onConnectWidget: function onConnectWidget(widgetId, portalId) {
      return dispatch((0, _nicbaseReducers.connectWidget)(widgetId, portalId));
    },
    onDisconnectWidget: function onDisconnectWidget(widgetId, portalId) {
      return dispatch((0, _nicbaseReducers.disconnectWidget)(widgetId, portalId));
    }
  };
};

exports.mapDispatchToProps = mapDispatchToProps;

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _nicbaseTranslation.injectIntl)(BaseWidget));

exports["default"] = _default;